import React from 'react';
import PropTypes from 'prop-types';
import {QRCodeSVG} from 'qrcode.react';
import {QRCodeCanvas} from 'qrcode.react';
import './qr.scss';

const QR = ({role, deviceInfo, url}) => {

	return (
		<div className={'QR ' + deviceInfo.orientation + ' ' + role}>
			<div className="QR-code">
				<QRCodeSVG
					id={'codeSvg'}
					value={url}
					bgColor={'#FFFFFF'}
					fgColor={'#000000'}
				/>
				<QRCodeCanvas
					id={'codePng'}
					value={url}
					bgColor={'#FFFFFF'}
					fgColor={'#000000'}
				/>
			</div>
		</div>
	);
};

QR.propTypes = {
	role: PropTypes.string.isRequired,
	deviceInfo: PropTypes.object.isRequired,
	url: PropTypes.string.isRequired
};

export default QR;